<!--
 * @Author: qinmengyuan
 * @Date: 2024-06-21 11:03:07
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-06-26 17:26:32
 * @FilePath: \onetab\src\components\OrderInfo.vue
-->
<template>
  <div class="mask" @click.self="handleClose">
    <Transition name="modal-fade" v-loading="!qrCodeData">
      <div class="modal" v-if="isShow">
        <div class="header">
          <div>订单信息</div>
          <RaIcon icon="Close" @click="handleClose" />
        </div>
        <div class="content">
          <div class="desc">打开{{ payMethod === 'wechat' ? '微信' : '支付宝' }}，扫码支付</div>
          <div class="money">¥{{ props.orderInfo.order_total / 100 }}</div>
          <div class="code" v-if="qrCodeData">
            <img :src="qrCodeData" alt="" />
          </div>
          <div class="account">
            <div
              class="item"
              style="
                border-bottom: 1px solid
                  var(--border-default, rgba(26, 26, 26, 0.05));
              "
            >
              <div class="label">购买账号</div>
              <div class="value">{{  user.email }}</div>
            </div>
            <div class="item">
              <div class="label">有效日期</div>
              <div class="value">{{ Util.formatDate(props.orderInfo.vip_end_date) }}</div>
            </div>
          </div>
          <div class="notice">本商品为虚拟商品，不支持退款</div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { RaIcon } from '@rafter/icon';
import { RaMessage } from '@rafter/pc';
import qrcode from 'qrcode';
import { queryOrder, wechatPay } from '@/api/userApi';
import { user } from '@/store/user';
import Util from '@/lib/Util';

const emits = defineEmits(['handleClose']);
const props = defineProps({
  orderInfo: {
    type: Object,
    required: true,
  }
});

const isShow = ref(false);
const open = ref(true);
const payInfo = ref("");
const payMethod = ref("wechat");
const qrCodeData = ref("");
const timer = ref(null);
const handleClose = () => {
  isShow.value = false;
  timer.value && clearInterval(timer.value);
  setTimeout(() => {
    emits('handleClose');
  }, 150);
};
const handleKeyDown = (event) => {
  if (event.key === 'Escape') {
    handleClose();
  }
};
onMounted(() => {
  isShow.value = true;
  document.addEventListener('keydown', handleKeyDown);

  if(payMethod.value === 'wechat'){
    wechatPay({order_no: props.orderInfo.order_no})
    .then(res=>{
      payInfo.value = res.data;
      qrcode.toDataURL(res.data, {
        width: 300,
        height: 300,
      }, (err, url) => {
        qrCodeData.value = url;
      });
    })
    .catch(e=>{
      console.log(e,'catch');
      RaMessage.error('请求服务器失败');
    });
  }

  timer.value = setInterval(() => {
    queryOrder({order_no: props.orderInfo.order_no})
    .then(res=>{
      if(res.data.code === 200 && res.data.data.pay_status){
        user.isVip = true;
        RaMessage.success('支付成功');
        
        // 刷新页面上所有的iframe
        const iframes = document.querySelectorAll('iframe');
        iframes.forEach(iframe => {
            iframe.src = iframe.src;
        });
        
        clearInterval(timer.value);
        setTimeout(() => {
          handleClose();
        }, 3000);
      }
    });
  }, 2000);
});
onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
});
</script>
<style lang="scss" scoped>
.mask {
  width: 100vw;
  height: 100vh;
  background-color: rgba(26, 26, 26, 0.4);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  .modal {
    display: flex;
    width: 520px;
    height: 640px;
    border-radius: $base-border-radiuse-24;
    user-select: none;
    position: absolute;
    z-index: 1;
    overflow: hidden;
    background: #f5f6ff;
    padding: 0 24px;
    flex-direction: column;
    align-items: center;
    .header {
      height: 56px;
      display: flex;
      align-items: center;
      width: -webkit-fill-available;
      justify-content: space-between;
      color: var(--Text-on-surface-secondary, #424751);
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
      i {
        border-radius: 50%;
        &:hover {
          background: #f56c6c !important;
          color: white !important;
        }
      }
    }
    .content {
      padding: 16px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      .desc {
        color: var(--Text-on-surface-primary, #181b22);
        text-align: center;

        /* web/cn/body/body-01 */
        font-family: 'PingFang SC';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 157.143% */
        letter-spacing: 0.5px;
      }
      .money {
        color: #eb8d00;
        text-align: center;
        font-family: 'MiSans VF';
        font-size: 40px;
        font-style: normal;
        font-weight: 450;
        letter-spacing: 4px;
      }
      .code {
        width: 256px;
        height: 256px;
        flex-shrink: 0;
        border-radius: 15.36px;
        background: url(<path-to-image>) lightgray 50% / cover no-repeat;
        overflow: hidden;
        
        img{
          width: 100%;
          height: 100%;
          // transform: scale(1.05);
        }
      }
      .account {
        display: flex;
        width: 256px;
        flex-direction: column;
        flex: 1;
        .item {
          display: flex;
          height: 44px;
          align-items: center;
          justify-content: space-between;
          color: var(--Text-on-surface-primary, #181b22);
          /* web/cn/body/body-01 */
          font-family: 'PingFang SC';
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 157.143% */
          letter-spacing: 0.5px;
        }
      }
      .notice {
        color: #7c7ca3;
        text-align: center;
        /* web/cn/helper/helper-02 */
        font-family: 'PingFang SC';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 18px */
        letter-spacing: 0.4px;
      }
    }
  }
}
</style>
